export default __webpack_public_path__ + "static/media/wildcard_logo.e053a277.png";